// Version string the bundle sends to the API as X-Dashboard-Version so a
// misbehaving client can be tied to the build it runs (2026-09-23 incident,
// item L). src/version.js is generated by scripts/update-version.js at build
// time and is not tracked, so tests and a bare checkout fall back to 'unknown'.
let version = 'unknown';
try {
  // eslint-disable-next-line global-require
  version = require('./version').APP_VERSION || version;
} catch (error) {
  // No generated version module: not a production build.
}
export const APP_VERSION = version;
export const DASHBOARD_VERSION_HEADER = 'x-dashboard-version';
